import { graphql } from '@/__generated__';
import { useQueryStable } from '../useQueryStable';

const GetAccountMaterializationTypes = graphql(/* GraphQL */ `
  query AccountMaterializationTypes($accountId: BigInt!) {
    account(id: $accountId) {
      materializationTypes {
        name
      }
    }
  }
`);

type Props = {
  accountId: number | undefined;
  pause?: boolean;
};

export const useAccountMaterializationTypes = ({ accountId = 0, pause }: Props) => {
  const query = useQueryStable({
    query: GetAccountMaterializationTypes,
    variables: { accountId },
    pause: pause || !accountId,
  });

  return query;
};
